@if (hasChoice) {
  <bic-select (valueChange)="onSelect($event)" [value]="value" label="KI-Modell"
              placeholder="Modell auswählen">
    @for (modelName of options; track modelName) {
      <bic-dropdown-element [value]="modelName">{{ modelName }}</bic-dropdown-element>
    }
  </bic-select>
} @else if (displayedModel) {
  <div class="flex flex-col gap-2">
    <!-- data-proposal-label: im Kopfzeilen-Modus von app-change-marker steht der Titel in dessen Kopfzeile. -->
    <span class="text-sm font-medium text-gray-900 leading-[1.5]" data-proposal-label>KI-Modell</span>
    <!-- Hinweis direkt neben dem Badge: er gehört zum angezeigten Modell, nicht zur Überschrift. -->
    <div class="flex flex-row items-center gap-3">
      <bic-badge type="info">{{ displayedModel }}</bic-badge>
      <button (click)="openEnterprisePopup()"
              class="flex items-center gap-1 text-xs text-gray-500 hover:underline shrink-0"
              type="button">
        <fa-icon [icon]="faCircleInfo" class="text-xs"></fa-icon>
        Weitere Modelle?
      </button>
    </div>
  </div>
}

@if (showEnterprisePopup) {
  <app-ai-model-enterprise-popup (closed)="onEnterprisePopupClosed()"
                                 (offerRequested)="onOfferRequested()"
                                 [currentModel]="displayedModel"/>
}
